export default "__VITE_ASSET__1270629a__"